<template>
  <div class="vx-row">
    <div class="vx-col mb-base w-full">
      <mensagem-somente-pro-teste v-if="dispositivo.apkversion.indexOf('2.66') === 0" />
      <div class="vx-card">
        <vx-card title="Áudios do WhatsApp">
          <div class="vx-row pt-2">
            <div class="flex justify-center vx-col w-full mb-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
                <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
                  <vs-pagination :total="meta.pagination.total_pages" v-model="page" :max="5"></vs-pagination>
                </div>
              </vs-col>
            </div>
            <div class="container" v-show="loading">
              <div id="loading" class="vs-con-loading__container"></div>
            </div>
            <div v-show="!data.length && !loading" class="text-center pt-5 container">
              <p class="text-grey">Nenhum item encontrado no período selecionado</p>
            </div>

            <div class="vx-col w-1/2 sm:w-4/12 text-center mt-2 mb-4 w-full" v-for="(item, index) in data" :key="index">
              <div v-if="!item.to_be_converted">
                <audio :key="item.url" :src="item.url" preload="metadata" controls :ref="`audio-${index}`"></audio>
              </div>
              <div v-else>
                <vs-button v-show="!item.converting" @click="convertAndPlay(item, index)"
                  ><i class="far fa-play"></i
                ></vs-button>
                <vs-button v-show="item.converting"><i class="far fa-spinner fa-pulse"></i></vs-button>
              </div>
              <div>{{ item.datetime | formatDateTime }}</div>
            </div>

            <div
              class="w-full"
              v-show="data.length > 0 && !loading && dispositivo.uid && dispositivo.licence.until === null"
            >
              <div class="vx-col w-full h-full prc-2">
                <vx-card slot="no-body" class="text-center h-full bg-primary-gradient greet-user">
                  <feather-icon
                    icon="AwardIcon"
                    class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                    svgClasses="h-8 w-8"
                  ></feather-icon>
                  <h1 class="mb-6 text-white">Aviso Importante</h1>
                  <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                    O restante do conteúdo foi bloqueado por sua conta estar na
                    <strong>Versão Gratuita</strong> desbloqueie o conteúdo agora mesmo.
                  </p>
                  <br />
                  <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                    <vs-button color="warning" type="relief">
                      <vs-icon icon-pack="fas" icon="fa-shopping-cart"></vs-icon>&nbsp;Liberar Conteúdo Completo
                    </vs-button>
                  </router-link>
                </vx-card>
              </div>
            </div>

            <div class="flex justify-center vx-col w-full mb-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
                <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
                  <vs-pagination :total="meta.pagination.total_pages" v-model="page"></vs-pagination>
                </div>
              </vs-col>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import MensagemSomenteProTeste from '../components/MensagemSomenteProTeste.vue';

export default {
  components: {
    MensagemSomenteProTeste
  },

  data() {
    return {
      processing: false,
      data: [],
      loading: true,
      dispositivo: {
        licence: {
          until: null
        }
      },
      meta: {
        pagination: {
          total_pages: 0
        }
      },
      page: 1,
      dateFilterId: 5,
      dateFilterText: 'Todos os Registros',
      isSafari: false
    };
  },

  watch: {
    page: function() {
      this.load();
    }
  },

  mounted() {
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    this.load();

    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1
    });
  },

  methods: {
    load: function() {
      this.loading = true;
      const mobile = JSON.parse(this.$localStorage.get('mobile'));
      this.data = [];
      this.$api
        .get(
          `/api/v${mobile.panel_version}/mobile/whatsappaudio/${mobile.uid}?page=${this.page}&dateFilterId=${this.dateFilterId}`
        )
        .then(response => {
          this.loading = false;
          if (response.data.data) {
            response.data.data.forEach(i => {
              if (i.url.indexOf('aac') === -1 && this.isSafari) {
                i.to_be_converted = true;
              }
              this.data.push(i);
            });
          }
          this.meta = response.data.meta || { pagination: { total_pages: 0 } };
        });

      this.$api.get(`/api/v${mobile.panel_version}/mobile/device/${mobile.uid}`).then(response => {
        this.dispositivo = response.data.data;
        this.$EventBus.$emit('deviceChanged', this.dispositivo);
      });
    },
    setDateFilter: function(filterId) {
      this.dateFilterId = filterId;
      this.load();

      switch (this.dateFilterId) {
        case 0:
          this.dateFilterText = 'Hoje';
          break;
        case 1:
          this.dateFilterText = 'Ontem';
          break;
        case 2:
          this.dateFilterText = 'Últimos 7 dias';
          break;
        case 3:
          this.dateFilterText = 'Últimos 30 dias';
          break;
        case 4:
          this.dateFilterText = 'Últimos 90 dias';
          break;
        case 5:
          this.dateFilterText = 'Todos os Registros';
          break;
      }
    },
    convertAndPlay: function(item, index) {
      const convertingCount = this.data.filter(i => i.converting === true).length;
      if (convertingCount > 0) {
        this.$vs.notify({
          time: 10000,
          title: 'Informação',
          text:
            'Um áudio já está sendo processado e irá tocar em breve. Aguarde antes de solicitar outro áudio. Essa limitação se dá ao fato do seu navegador ser o Safari que é incompatível com o tipo de arquivo original.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'primary'
        });

        return;
      }

      item.converting = true;
      this.$set(this.data, index, item);

      const mobile = JSON.parse(this.$localStorage.get('mobile'));
      this.$api
        .post(`/api/v${mobile.panel_version}/mobile/whatsappaudio/${mobile.uid}/convert`, item)
        .then(response => {
          item.converting = false;
          item.url = response.data.url;
          item.to_be_converted = false;
          this.$set(this.data, index, item);
        })
        .catch(error => {
          item.converting = false;
          this.$set(this.data, index, item);

          let errors = [];
          if (error.response.data.message) {
            errors.push(error.response.data.message);
          } else {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                const element = error.response.data[key];
                errors.push(element);
              }
            }
          }

          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>

<style>
#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
